import Cookies from 'js-cookie';
// import { createAvatar } from './common';

// use localStorage to store the authority info, which might be sent from server in actual project.
export function getAuthority(str) {
  // return localStorage.getItem('antd-pro-authority') || ['admin', 'user'];
  const authorityString =
      typeof str === 'undefined' ? localStorage.getItem('access-authority') : str;
  // authorityString could be admin, "admin", ["admin"]
  let authority;
  try {
    authority = JSON.parse(authorityString);
  } catch (e) {
    authority = authorityString;
  }
  if (typeof authority === 'string') {
    return [authority];
  }
  return authority || ['guest'];
}

export function getRole() {
  const roles = getAuthority();
  if (roles && roles[0]) return roles[0];
  return roles;
}

export function setAuthority(authority) {
  const proAuthority = typeof authority === 'string' ? [authority] : authority;
  return localStorage.setItem('access-authority', JSON.stringify(proAuthority));
}

export function getAccessToken() {
  return Cookies.get('sas_school_token');
  // return localStorage.getItem('access-token');
}
export function getSchoolYear() {
  return Cookies.get('sas_school_year');
}
export function setSchoolYear(yearId) {
  Cookies.set('sas_school_year', yearId);
}
export function getSchoolYearName() {
  return Cookies.get('sas_school_year_name');
}
export function setSchoolYearName(yearName) {
  Cookies.set('sas_school_year_name', yearName);
}
export function getSchoolId() {
  return Cookies.get('sas_school_id');
}
export function setSchoolId(schoolId) {
  Cookies.set('sas_school_id', schoolId);
}
export function getSchoolAbbreviationName() {
  return Cookies.get('sas_school_abbreviation_name');
}
export function setSchoolAbbreviationName(name) {
  Cookies.set('sas_school_abbreviation_name', name);
}
export function setAccessToken(token, day) {
  return Cookies.set('sas_school_token', token, {expires: day});
  // return localStorage.setItem('access-token', token);
}

export function getRefreshToken() {
  return localStorage.getItem('access-refresh');
}

export function setRefreshToken(token) {
  return localStorage.setItem('access-refresh', token);
}

export function getCurrentUserEmail() {
  return localStorage.getItem('access-email');
}

export function setCurrentUserEmail(email) {
  return localStorage.setItem('access-email', email);
}

export function getCurrentLang() {
  return localStorage.getItem('access-lang') || 'vi';
}

export function setCurrentLang(lang) {
  return localStorage.setItem('access-lang', lang);
}

export function getAvatar() {
  return localStorage.getItem('access-avatar') || '';
}

export function setAvatar(avatar) {
  return localStorage.setItem('access-avatar', avatar);
}

export function getUserDetail() {
  return JSON.parse(localStorage.getItem('sas_school_userDetail')) || "";
}

export function getUserInfo() {
  return JSON.parse(localStorage.getItem('sas_school_userInfo')) || "";
}

export function forceLogout() {
  localStorage.removeItem('province');
  localStorage.removeItem('username');
  localStorage.removeItem('sas_school_language');
  localStorage.removeItem('sas_school_userType');
  localStorage.removeItem('sas_school_per');

  Cookies.remove('sas_school_id');
  Cookies.remove('sas_school_year');
  Cookies.remove('sas_school_token');
  Cookies.remove('sas_school_year_name');
  Cookies.remove('sas_school_abbreviation_name');
  return window.location.reload()
}

